import {DEFAULT_LANGUAGE_CODE, LANGUAGES} from "config";

// Derived from the LANGUAGES registry in config — add a language there, not here.
export const SUPPORTED_LANGUAGES = LANGUAGES.map((language) => language.code);

export type SupportedLanguage = typeof LANGUAGES[number]["code"];

export const DEFAULT_LANGUAGE = DEFAULT_LANGUAGE_CODE as SupportedLanguage;

const RTL_LANGUAGES: readonly string[] = LANGUAGES.filter((l) => l.rtl).map((l) => l.code);

/** Whether a language is written right-to-left — the `dir` attribute and the
 *  `rtl` style mixin both key off this, so it is a property of the language
 *  registry rather than a `lang === "ar"` check scattered around. */
export const isRTL = (lang: SupportedLanguage): boolean => RTL_LANGUAGES.includes(lang);
